import { createSlice } from "@reduxjs/toolkit"

export interface RoomsState {
    rooms: any[]
    selectedRoom: any
    lastSelectedRoom: any
    isLoading: boolean
    // Refetch de la habitación seleccionada en curso; el drawer muestra un skeleton mientras tanto
    isLoadingSelectedRoom: boolean
    roomsDimensions?: {
        x: number,
        y: number
    }
    roomsGrid?: {
        rows: number,
        cols: number
    }
}

const initialState: RoomsState = {
    rooms: [],
    selectedRoom: {},
    lastSelectedRoom: {},
    isLoading: true,
    isLoadingSelectedRoom: false,
}

export const roomsSlice = createSlice({
    name: "rooms",
    initialState,
    reducers: {
        setRooms: (state, action) => {
            state.rooms = action.payload
            state.isLoading = false
        },
        setIsLoading: (state, action) => {
            state.isLoading = action.payload
        },
        setIsLoadingSelectedRoom: (state, action) => {
            state.isLoadingSelectedRoom = action.payload
        },
        selectRoom: (state, action) => {
            state.selectedRoom = action.payload
            if (Object.keys(action.payload).length > 0) { 
                state.lastSelectedRoom = action.payload;
            }
        },
        selectRoomById: (state, action) => {
            const room = state.rooms.find(r => r.habitacion_id === action.payload.habitacion_id)
            if (room) {
                state.selectedRoom = room
                state.lastSelectedRoom = room 
            }
        },
        updateRoom: (state, action) => {
            state.rooms = state.rooms.map((r) => {
                if (r.habitacion_id === action.payload.habitacion_id) {
                    // Se mezcla en lugar de reemplazar: los payloads que llegan aquí
                    // (mutación de estado, GET_ROOM) no traen todos los campos que usa el
                    // plano, y reemplazar borraba los ausentes -- p. ej. alerta_incidencia,
                    // con lo que la card perdía el banderín de incidencia al cambiar de estado.
                    return { ...r, ...action.payload }
                }
                return r
            })
            state.selectedRoom = action.payload
            state.lastSelectedRoom = action.payload 
        },
        setRoomsDimensions: (state, action) => {
            state.roomsDimensions = action.payload
        },
        setRoomsGrid: (state, action) => {
            state.roomsGrid = action.payload
        },
        clearSelectedRoom: (state) => {
            state.selectedRoom = {}
            state.lastSelectedRoom = {}
        },
    },
})

// Action creators are generated for each case reducer function
export const {
    setRooms,
    selectRoom,
    updateRoom,
    selectRoomById,
    setRoomsDimensions,
    setRoomsGrid,
    setIsLoading,
    setIsLoadingSelectedRoom,
    clearSelectedRoom,
} = roomsSlice.actions

export default roomsSlice.reducer
